module.exports = __webpack_public_path__ + "static/media/payment-visa.32891d2e.jpg";